var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var levels = { debug: -1, log: 0, info: 0, warn: 1, error: 2 };
var record = function (logLevel, targetLevel, bizName, targetBizName) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (targetLevel && levels[targetLevel] <= levels[logLevel]) {
            // IE9 下没有 apply 函数
            if (console[logLevel].apply && (targetBizName === '*' || bizName.startsWith(targetBizName))) {
                return console[logLevel].apply(console, getLogArgs(args, bizName));
            }
        }
    };
};
function getLogArgs(args, bizName) {
    if (bizName !== '*') {
        if (typeof args[0] === 'string') {
            args[0] = "[" + bizName + "] " + args[0];
        }
        else {
            args = ['[' + bizName + ']'].concat(args);
        }
    }
    return args;
}
function parseLogConf(logConf, options) {
    if (!logConf) {
        return {
            targetLevel: options.level,
            targetBizName: options.bizName
        };
    }
    if (~logConf.indexOf(':')) {
        var pair = logConf.split(':');
        return {
            targetLevel: pair[0],
            targetBizName: pair[1]
        };
    }
    return {
        targetLevel: logConf,
        targetBizName: '*'
    };
}
var defaultOptions = {
    level: 'warn',
    bizName: '*'
};
var Logger = /** @class */ (function () {
    function Logger(options) {
        options = __assign(__assign({}, defaultOptions), options);
        var _location = location || {};
        // __logConf__ 格式为 logLevel[:bizName]
        //   1. log|warn|debug|error
        //   2. log|warn|debug|error:*
        //   3. log|warn|debug|error:bizName
        var logConf = (((/__(?:logConf|logLevel)__=([^#/&]*)/.exec(_location.href)) || [])[1]);
        var _a = parseLogConf(logConf, options), targetLevel = _a.targetLevel, targetBizName = _a.targetBizName;
        for (var logLevel in levels) {
            this[logLevel] = record(logLevel, targetLevel, options.bizName, targetBizName);
        }
    }
    return Logger;
}());
export default Logger;
